class TabsController
  @$inject = [ '$scope', 'pathService', 'promiseTracker', 'authService', 'confirmacoesPendentesService' ]

  constructor: (@scope, pathService, @promiseTracker, authService, confirmacoesPendentesService) ->
    @url = pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/';
    @loadingTracker = @promiseTracker()

    @loadingTracker.addPromise confirmacoesPendentesService.getList((result) =>
      if result.success
        @listOfConfirmacoesPendentes = result.data
      else
        @Alert.error('Ocorreu um erro ao buscar as confirmações pendentes.', 'Erro!', false)
    )

    @tabsView = [ {
      id: 'painel'
      label: 'Painel'
      url: @url + 'painel.html'
    } ]

    buttons = {
      sistema: [
        { label: 'Atividades econômicas', url: 'area-atuacao/index.html', icon: 'object-ungroup' },
        { label: 'Banco de dados código de barras', url: 'codigo-barras-ncm/index.html', icon: 'database' },
        { label: 'Configurações avançadas', url: 'configuracoes-avancadas.html', icon: 'cogs' }
        { label: 'Confirmação de inconsistências de NCM', url: 'ncm-inconsistente/index.html', icon: 'check', permission: {resource: 'EficienciaFiscal\\NcmInconsistente', privilege: 'GET'} },
        { label: 'Ferramentas do dashboard', url: 'ferramenta-dashboard/index.html', icon: 'cog' },
        { label: 'Ramos de atividades', url: 'atividade/index.html', icon: 'sitemap' },
        { label: 'Regimes tributários', url: 'regime-tributario/index.html', icon: 'book' },
        { label: 'Serviços e categorias financeiras', url: 'servicos/index.html', icon: 'money' },
        { label: 'Tabela TIPI/TEC (NCM)', url: 'ncm/index.html', icon: 'table' },
        { label: 'Termos de uso', url: 'termo-de-uso/index.html', icon: 'file-text' },
        { label: 'CFOPs confiáveis', url: 'cfop-confiavel/index.html', icon: 'book' },
        # { label: 'CNPJs confiáveis', url: 'cnpj-confiavel/index.html', icon: 'book' },
        { label: 'Regras de validação', url: 'regra-validacao/index.html', icon: 'book' },
      ],
      pis_cofins: [
        { label: 'CFOP geradoras de créditos', url: 'cfop-credito/index.html', icon: 'book' },
        { label: 'Chave de busca por tabela SPED', url: 'tabelas-sped/chave-busca/index.html', icon: 'table' },
        { label: 'Confirmação de exceções PIS/COFINS', url: 'pis-cofins/excecao-confirmada/index.html', icon: 'check', permission: {resource: 'EficienciaFiscal\\ExcecaoConfirmadaPisCofins', privilege: 'GET'} },
        { label: 'Confirmação de ExTIPI', url: 'pis-cofins/confirmacao-ex-tipi/index.html', icon: 'check', permission: {resource: 'EficienciaFiscal\\ConfirmacaoExTipi', privilege: 'GET'} },
        { label: 'CST para PIS e COFINS', url: 'cst/index.html', icon: 'book' },
        { label: 'Grupos das tabelas PIS e COFINS', url: 'segmento/index.html', icon: 'table' },
        { label: 'Natureza', url: 'pis-cofins/natureza/index.html', icon: 'book' },
        { label: 'Tabelas do SPED contribuições', url: 'tabelas-sped/index.html', icon: 'table' },
        { label: 'Vinculação das tabelas SPED contribuições', url: 'situacao/index.html', icon: 'exchange' },
        { label: 'Parametrização PIS/COFINS por CFOP', url: 'pis-cofins/configuracao-cfop/index.html', icon: 'exchange' },
        { label: 'Parametrização PIS/COFINS por Grupo e Atividade', url: 'pis-cofins/configuracao-grupo/index.html', icon: 'exchange' },
      ],
      icms: [
        { label: 'Alertas por CFOP', url: 'icms/cfop-alerta/index.html', icon: 'warning' },
        { label: 'Alíquotas de antecipação', url: 'icms/aliquota-antecipacao/index.html', icon: 'font' },
        { label: 'Alíquotas estaduais ICMS', url: 'icms/aliquota-estadual/index.html', icon: 'font' },
        { label: 'Alíquotas internas ICMS', url: 'icms/aliquota-estadual-especifica/index.html', icon: 'font' },
        { label: 'Aplicações ICMS', url: 'icms/aplicacao/index.html', icon: 'gavel' },
        { label: 'Atividades econômicas ICMS', url: 'icms/area-atuacao/index.html', icon: 'object-ungroup' },
        { label: 'CEST (Código especificador da substituição tributária)', url: 'icms/segmento-mercadoria-cest/index.html', icon: 'table' }
        { label: 'CFOP excludente', url: 'icms/cfop-excludente/index.html', icon: 'minus-circle' }
        { label: 'Confirmação de alíquotas especias de código de barras', url: 'icms/aliquota-codigo-barras/index.html', icon: 'check', permission: {resource: 'EficienciaFiscal\\AliquotaCodigoBarras', privilege: 'GET'} },
        { label: 'Confirmação de exceções ICMS', url: 'icms/excecao-confirmada/index.html', icon: 'check', permission: {resource: 'EficienciaFiscal\\ExcecaoConfirmadaIcms', privilege: 'GET'} },
        { label: 'Convênio', url: 'icms/convenio/index.html', icon: 'book' }
        { label: 'CSOSN', url: 'icms/csosn/index.html', icon: 'book' }
        { label: 'CST ICMS', url: 'icms/cst-icms/index.html', icon: 'book' }
        { label: 'Desvios ST (Farmacêuticos, ...)', url: 'icms/desvios-st//index.html', icon: 'mail-forward' }
        { label: 'Exclusão de NCM por atividade para D.A./A.T.', url: 'icms/ncm-exclusao-atividade/index.html', icon: 'minus-circle' }
        { label: 'Exclusão do cálculo de entrada por atividade econômica', url: 'icms/exclusao-area-atuacao/index.html', icon: 'minus-circle' }
        { label: 'Perfis', url: 'icms/perfil/index.html', icon: 'users' }
        { label: 'Regime tributário', url: 'icms/regime-tributario/index.html', icon: 'book' }
        { label: 'Regras de exclusão para D.A e A.T por anexo', url: 'icms/regra-exclusao-por-anexo/index.html', icon: 'list' }
        { label: 'CEST (Segmento de mercadoria)', url: 'icms/segmento-mercadoria/index.html', icon: 'list' }
        { label: 'Tabela de origem ICMS', url: 'icms/tabela-origem/index.html', icon: 'table' },
        { label: 'Tabelas ICMS', url: 'icms/item-tabelas/tabs/index.html', icon: 'table' }
        { label: 'Vedação de aproveitamento de crédito', url: 'icms/vedacao-aproveitamento-credito/index.html', icon: 'ban' }
        { label: 'CFOPs ICMS', url: 'icms/cfop-icms/index.html', icon: 'book' }
        { label: 'Tipos destinação', url: 'icms/tipo-destinacao/index.html', icon: 'mail-forward' }
      ]
    }

    authService.getPermissions( @getPermissions(buttons), (result) =>
      @buttons = {}
      for group, groupButtons of buttons
        @buttons[group] = groupButtons.filter((button) =>
          permission = @getPermission(button)
          result[permission.resource.replace(/\\/g, '_')][permission.privilege]
        )
    )

  getPermissions: (buttons) ->
    Object
      .values(buttons)
      .reduce(((a, b) -> a.concat(b)), [])
      .map(@getPermission)
      .reduce(@groupPermissions, {})

  getPermission: (button) ->
    button.permission || {resource: 'EficienciaFiscal\\ItemTabela', privilege: 'GET'}

  groupPermissions: (permissions, permission)   ->
    permissions[permission.resource] or= []
    permissions[permission.resource].push(permission.privilege) if permissions[permission.resource].indexOf(permission.privilege) == -1
    permissions

  openConfig: (button) ->
    @scope.tabController.addTab({
      id: button.url
      label: button.titleTab or button.label
      closable: true
      url: @url + button.url
    })

angular.module('eficienciaFiscalModule').controller('configuracaoTabsController', TabsController)
